var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubdashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114 519 c-10 -17 -17 -134 -10 -163 6 -26 7 -26 106 -26 l100 0 0 100 0 100 -94 0 c-59 0 -97 -4 -102 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 430 l0 -100 100 0 c99 0 100 0 106 26 7 29 0 146 -10 163 -5 7 -43 11 -102 11 l-94 0 0 -100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 284 c-9 -36 2 -154 15 -167 7 -7 46 -12 99 -12 l87 0 3 103 3 102 -100 0 c-100 0 -101 0 -107 -26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 208 l3 -103 87 0 c53 0 92 5 99 12 13 13 24 131 15 167 -6 26 -7 26 -107 26 l-100 0 3 -102z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubdashboard);
export default __webpack_public_path__ + "static/media/subdashboard.5d2f0ae88a01dd89bb7751f2f51552e3.svg";
export { ForwardRef as ReactComponent };